const smoothScroll = {
    init() {
        document.addEventListener('click', (e) => {
            const link = e.target.closest('.js-smooth-scroll');

            if (!link) {
                return;
            }

            const target = document.querySelector(link.getAttribute('href'));

            if (!target) {
                return;
            }

            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }
}

export default smoothScroll
